import { config } from "../config";

// Plain-function version of useApiHeaders — usable outside a hook, for
// building headers against a provider the user picks at click-time (e.g. a
// duplicate's target cluster), not just the current page's own context.
export function buildApiHeaders({ accessToken, roles, platformName, vaultId, awsProfile, userDisplayName = "" }) {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    Roles: roles?.join(",") ?? "",
  };

  if (userDisplayName) {
    headers["X-User-Display-Name"] = userDisplayName;
  }

  if (platformName === config.platforms[0]) {
    const profile = config.awsProfiles[awsProfile];
    if (profile) {
      headers.smRegion  = profile.region;
      headers.smAccount = profile.account;
    } else {
      headers.smRegion = vaultId;
    }
  } else {
    headers.vaultName = vaultId;
  }

  return headers;
}
